export const textShortener = (text: string, letterLimit: number) =>
  text.substr(0, letterLimit) + '\u2026'
